export const FONT_PATH = '//alfabank.st/media/about/fonts/fonts.css';
